import React from 'react';
import { useTheme } from 'next-themes';
import { Button } from '../ui/button';
import { Moon, Sun } from 'lucide-react';
import { cn } from '../../lib/utils';

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggleTheme}
      className={cn(
        "relative overflow-hidden transition-all duration-500 ease-in-out",
        "hover:scale-105 active:scale-95",
        "h-9 w-9 border-2",
        className
      )}
    >
      <div className="relative w-full h-full flex items-center justify-center">
        {/* Sun Icon */}
        <Sun
          className={cn(
            "h-[1.2rem] w-[1.2rem] absolute transition-all duration-500 ease-in-out",
            theme === 'light'
              ? "rotate-0 scale-100 opacity-100"
              : "rotate-90 scale-0 opacity-0"
          )}
        />

        {/* Moon Icon */}
        <Moon
          className={cn(
            "h-[1.2rem] w-[1.2rem] absolute transition-all duration-500 ease-in-out",
            theme === 'dark'
              ? "rotate-0 scale-100 opacity-100"
              : "-rotate-90 scale-0 opacity-0"
          )}
        />
      </div>

      {/* Simple background - no gradient */}
      <div
        className={cn(
          "absolute inset-0 rounded-md transition-all duration-500 ease-in-out opacity-10",
          theme === 'light'
            ? "bg-yellow-300"
            : "bg-gray-600"
        )}
      />
    </Button>
  );
}
